import { useEffect, useState } from 'react';

import ShareOutlined from '@mui/icons-material/ShareOutlined';
import { Dialog, IconButton, Tooltip } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import httpInstances from '@/api/axiosInstance';
import ShareDialogContent from '@/pages/Markets/MarketsComponents/Share/ShareDialogContent';
import copyToClipboard from '@/utils/copyToClipboard';
import { emailValidator } from '@/utils/validators';

export enum ShareBlockNames {
  ForwardCurveChart = 'Forward Curve Chart',
  SeasonalChart = 'Seasonal Chart',
  SpotChart = 'Spot Chart',
  Feed = 'Feed',
  Table = 'Table',
  Tables = 'Tables',
  CSVTable = 'CSV Table',
  CustomChart = 'Custom Chart',
  Files = 'Data lake files'
}

export const ShareBlock = ({
  blockName,
  activeTabName,
  shareTabParam
}: {
  activeTabName?: string;
  blockName: ShareBlockNames;
  shareTabParam: string;
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');
  const [recipient, setRecipient] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');

  useEffect(() => {
    setContent('');
    setEmailError('');
    setRecipient('');
  }, [modalOpen]);

  const shareUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?element=${shareTabParam}`;

  const sendEmail = async () => {
    const errorMessage = emailValidator(recipient);
    if (errorMessage) {
      setEmailError(errorMessage);
      return;
    }
    try {
      enqueueSnackbar('Email is sending, please wait...', {
        variant: 'loading'
      });
      setModalOpen(false);
      await httpInstances.axiosGoInstance.post(`/share`, {
        content,
        recipient,
        url: shareUrl
      });
      enqueueSnackbar('Email sent!', {
        variant: 'success',
        autoHideDuration: 5000
      });
    } catch {
      enqueueSnackbar('Something went wrong!', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };
  const handleCopyToClipboard = () => {
    copyToClipboard(shareUrl, 'Link copied to clipboard!');
  };

  const handleChangeRecipient = (value: string) => {
    setEmailError('');
    setRecipient(value);
  };
  const header = `Share ${activeTabName} ${activeTabName === blockName ? '' : blockName}`;

  return (
    <>
      <Tooltip
        slotProps={{
          popper: {
            sx: { zIndex: 9999 }
          }
        }}
        title='Share'
      >
        <IconButton
          sx={{
            width: 30,
            height: 48,
            p: 0,
            minWidth: 30,
            borderRadius: 0,
            backgroundColor: 'secondary.main'
          }}
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <ShareOutlined sx={{ fontSize: '14px' }} />
        </IconButton>
      </Tooltip>
      <Dialog
        open={modalOpen}
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: 'blur(2px)',
              backgroundColor: 'rgba(18, 22, 63, 0.80)'
            }
          }
        }}
        sx={{
          zIndex: 9999
        }}
        onClose={() => {
          setModalOpen(false);
        }}
      >
        <ShareDialogContent
          content={content}
          emailError={emailError}
          handleChangeRecipient={e => {
            handleChangeRecipient(e.target.value);
          }}
          header={header}
          recipient={recipient}
          shareUrl={shareUrl}
          onContentChange={e => {
            setContent(e.target.value);
          }}
          onCopyClick={handleCopyToClipboard}
          onSendEmail={sendEmail}
        />
      </Dialog>
    </>
  );
};
